import "rxjs/add/observable/of";
import "rxjs/add/observable/throw";

import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/do";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/finally";
import "rxjs/add/operator/merge";
import "rxjs/add/operator/pairwise";



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/rxjs-extensions.ts